module.exports = __webpack_public_path__ + "edbd91af8df411a54834f86804143fd4.jpg";